// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"3bd7b82d","122":"76a59d3b","453":"1e3ca2a7"}[chunkId] + ".chunk.js";
};